export default __webpack_public_path__ + "static/media/right_PC.6556eaf7.svg";